import React, { Component } from 'react';
import { Popover } from 'antd';
import { CompactPicker } from 'react-color';
import styled from 'react-emotion';
import { color } from 'styled-system';

import withLabelAndMeta from './withLabelandMeta';
import { bouncyBoyMixin } from '../../styles';

const ColourToggler = styled('div')`
  width: 2em;
  height: 2em;
  ${color}
  border-radius: 4px;
  margin-bottom: .3em;
  cursor: pointer;
  ${bouncyBoyMixin}
`;

/* DCRPCompactColourPicker boxshadow removed in styles/index.js */


class Colour extends Component {
  render() {
    const {
      field, // { name, value, onChange, onBlur }
      fieldDefinition,
      setFieldValue,
    } = this.props;
    return (
      <Popover
        trigger="click"
        placement="bottomLeft"
        overlayClassName="DCRPCompactColourPicker"
        content={(
          <CompactPicker
            id={fieldDefinition.key}
            {...field}
            color={field.value}
            onChange={value => setFieldValue(fieldDefinition.key, value.hex)}
            onClose={this.closePicker}
          />
        )}
      >
        <ColourToggler bg={field.value} onClick={this.togglePicker} />
      </Popover>
    );
  }
}

export default withLabelAndMeta(Colour);
